import { useContext, useState } from "react";
import AiBody from "../AiBody/AiBody";
import AiModal from "../AiModal/AiModal";
import styles from "./AiButton.module.css";
import { HiSparkles } from "react-icons/hi2";
import { UserDataContext } from "../../../../UserContext";
import RPTBody from "../RPTBody/RPTBody";
import {
  useLocation,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import useAiChat from "../../hooks/useAiChat";
import { useMixPanelForTracking } from "../../../../Shared_utilities/trackmixpanel";

const FooterComponent = () => {
  return (
    <div>
      This is a generative AI chatbot. By interacting with it, you agree to
      LoRRI's{" "}
      <a
        href="https://www.lorri.in/terms-of-use"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms of Use
      </a>{" "}
      and{" "}
      <a
        href="https://www.lorri.in/acceptable-use-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Acceptable Use Policy
      </a>
      .
    </div>
  );
};

export default function AiButton() {
  const [userData, setUserData, fetchUserData] = useContext(UserDataContext);

  const [replyTo, setReplyTo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState("chat"); // "rpt"
  const location = useLocation();
  const history = useHistory();

  const {TrackMixPanel} = useMixPanelForTracking()
  // this hook and the state reply to should not be here, this is a anti pattern,
  // ideally the contents of this hook should be in a react query cache or redux states
  const { chatHistory, allowedPrompts, sendPrompt, resetChat, setChatHistory } =
    useAiChat({
      userData,
      location,
      history,
      replyTo,
    });

  const handleOpen = () => {
     TrackMixPanel({
      ModuleName: "lorri ai",
      Definition: `user has clicked on the ai button.`
    });
    setShowModal(true);
  };

  return (
    <>
      <div className={styles.container} onClick={handleOpen}>
        <div className={styles.rayContainer}>
          <div className={styles.rayOuter}></div>
          <div className={styles.rayInner}></div>
          <button className={styles.ai_button}>
            {/* <FaRobot className={styles.icon} /> */}
            <HiSparkles className={styles.ai_icon} />
          </button>
        </div>
      </div>

      <AiModal
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
          fetchUserData();
        }}
        titleContent={
          <div className={styles.headerWithTabs}>
            <div className={styles.WelcomeTitle}>LoRRI Intelligence</div>
            <div className={styles.tabContainer}>
              <div
                className={`${styles.tab} ${
                  selectedTab === "chat" ? styles.activeTab : ""
                }`}
                onClick={() => setSelectedTab("chat")}
              >
                Chat
              </div>
              <div
                className={`${styles.tab} ${
                  selectedTab === "rpt" ? styles.activeTab : ""
                }`}
                onClick={() => setSelectedTab("rpt")}
              >
                RPT
              </div>
            </div>
          </div>
        }
        footerContent={<FooterComponent />}
      >
        {/* <AiBody /> */}
        {selectedTab === "chat" ? (
          <AiBody
            chatHistory={chatHistory}
            allowedPrompts={allowedPrompts}
            sendPrompt={sendPrompt}
            resetChat={resetChat}
            setChatHistory={setChatHistory}
            setReplyTo={setReplyTo}
            replyTo={replyTo}
          />
        ) : (
          <RPTBody />
        )}
      </AiModal>
    </>
  );
}
